import moment from 'moment';

import { APP_LOCAL_DATETIME_FORMAT, APP_LOCAL_DATETIME_FORMAT_Z } from 'app/config/constants';

export const convertDateTimeFromServer = date => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeToServer = date => (date ? moment(date, APP_LOCAL_DATETIME_FORMAT_Z).toDate() : null);

export const convertStringToDate = str => {
  let date = moment(str, 'YYYYMMDD');
  let strDate = date.format('YYYY/MM/DD');
  return new Date(strDate);
};

export const convertStringToDateAndFormatter = (str, formmater) => {
  let date = moment(str, 'DD/MM/YYYY');
  let strDate = date.format(formmater);
  return new Date(strDate);
};

export const convertDateToString = (date, fommatter) => {
  return moment(date).format(fommatter);
};

export const convertDateToMillisecond = date => {
  return date.getTime();
};

export const formatterDate = date => {
  let str = '';
  if (date && date.includes('-')) return date;
  if (date) {
    let currentDate = new Date();
    let day = currentDate.getDate();
    let month = currentDate.getMonth() + 1;
    let arrDate = date.split('/');
    if (arrDate.length == 3) {
      str = arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0];
    } else if (arrDate.length == 2) {
      str = arrDate[1] + '-' + arrDate[0] + '-' + day;
    } else {
      str = date + '-' + month + '-' + day;
    }
  }
  return str;
};
